/** Template / onboarding step keys for dry runs (e.g. dry_run_1, dry_run_extra). */
export function isDryRunStepKey(stepKey: string): boolean {
  return stepKey.startsWith('dry_run');
}
